import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  Alert,
  Badge,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";

//import images
import boreholeSvg from "../../../assets/images/svg/undergroundWaterHole.svg";
import TableContainer from "Components/Common/TableContainer";
import { numberWithCommas } from "../../../helpers/globalHelper";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useCommonDataFindAllQuery, useBoreholeCreateMutation, useBoreholeDeleteMutation, useBoreholeFindAllQuery, useBoreholeUpdateMutation } from "store";
import DeleteModal from "Components/Common/DeleteModal";
import Dropzone from "react-dropzone";
import Switch from "react-switch";
import ShapeUpload from "Components/fileUpload/ShapeUpload";

const Detail = ({ searchField }: any) => {
  const [customQuery, setCustomQuery] = useState<any>();
  const [modal_backdrop, setmodal_backdrop] = useState(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isLoading, setLoading] = useState(true);

  const [boreholeOne, setBoreholeOne] = useState<any>();
  const [boreholeList, setBoreholeList] = useState<any>();
  const [boreholeCount, setBoreholeCount] = useState<any>();

  const [resetFiles, setResetFiles] = useState<boolean>(false);
  const [selectedFiles, setSelectedFiles] = useState<any>([]);

  // Datatable дээр pagination харуулахад хэрэгтэй
  const [customPagination, setCustomPagination] = useState<any>();
  const [customPageSize, setCustomPageSize] = useState<any>();
  const [customPageLength, setCustomPageLength] = useState<any>();

  const { data, error, isFetching } = useBoreholeFindAllQuery(customQuery);

  const [mineralBoolean, setMineralBoolean] = useState<boolean>(false);

  const [boreholeUpdate, boreholeUpdateResult] = useBoreholeUpdateMutation();
  const [boreholeCreate, boreholeCreateResult] = useBoreholeCreateMutation();
  const [boreholeDelete, boreholeDeleteResult] = useBoreholeDeleteMutation();

  const {
    data: cost_source,
    error: cost_sourceError,
    isFetching: isCost_sourceFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmn_invesetment_source`);

  useEffect(() => {
    setBoreholeList(data?.data);
    setLoading(false);
    setBoreholeCount(boreholeList?.length);

    const tempMineral = boreholeOne !== null ? boreholeOne?.is_mineral : false;
    setMineralBoolean(tempMineral)

    setCustomPagination(data?.pagination);
    const tempQuery = `?page=${customPageLength !== undefined ? customPageLength : 1
      }&pageSize=${customPageSize !== undefined ? customPageSize : 25}&${searchField !== undefined ? searchField : ''}`;
    setCustomQuery(tempQuery);
  }, [data, boreholeList, customPageSize, customPageLength, customPagination, searchField]);

  const toggle = useCallback(() => {
    if (modal_backdrop) {
      setmodal_backdrop(false);
      setBoreholeOne(null);
    } else {
      setmodal_backdrop(true);
    }
  }, [modal_backdrop]);

  const handleJobClick = useCallback((arg: any) => {
    const boreholeData = arg;

    setBoreholeOne({
      id: boreholeData.id,
      code: boreholeData.code,
      budget_cost: boreholeData.budget_cost,
      cmn_invesetment_source: boreholeData.cmn_invesetment_source,
      usage_date: boreholeData.usage_date,
      depth: boreholeData.depth,
      diameter: boreholeData.diameter,
      sea_level_m: boreholeData.sea_level_m,

      borehole_design: boreholeData.borehole_design,
      bored_organization: boreholeData.bored_organization,
      drilling_method_brand: boreholeData.drilling_method_brand,
      location: boreholeData.location,
    });
    setMineralBoolean(boreholeData?.is_mineral)

    setIsEdit(true);
    toggle();
  }, []);

  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (boreholeData) => {
    setBoreholeOne(boreholeData);
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (boreholeOne) {
      boreholeDelete(boreholeOne.id);
      setDeleteModal(false);
    }
  };

  const handleJobClicks = () => {
    setIsEdit(false);
    setBoreholeOne(null);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        header: "№",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Код",
        accessorKey: "code",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Зөвшөөрөл",
        accessorKey: "bored_organization",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => {
          switch (cellProps.row.original.bored_organization) {
            case true:
              return (
                <span className="badge badge-soft-success fw-semibold fs-6 text">
                  Зөвшөөрөлтэй
                </span>
              );
            case false:
              return (
                <span className="badge badge-soft-danger fw-semibold fs-6 text">
                  Зөвшөөрөлгүй
                </span>
              );
            default:
              return (
                <span className="badge badge-soft-warning fw-semibold fs-6 text">
                  Тодорхойгүй
                </span>
              );
          }
        },
      },
      {
        header: "Рашаан эсэх",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "is_mineral",
        cell: (cellProps: any) => {
          switch (cellProps.row.original.is_mineral) {
            case true:
              return (
                <span className="badge badge-soft-success fw-semibold fs-6 text">
                  Тийм
                </span>
              );
            default:
              return (
                <span className="badge badge-soft-primary fw-semibold fs-6 text">
                  Үгүй
                </span>
              );
          }
        },
      },
      {
        header: "Байршил",
        accessorKey: "location",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Үйлдэл",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                <Link to={`/under/ground/water/hole/show/${cellProps.row.original.id}`} className="btn btn-sm btn-soft-primary">
                  <i className="mdi mdi-eye-outline" id="viewtooltip"></i>
                </Link>
                <UncontrolledTooltip placement="top" target="viewtooltip">
                  Харах
                </UncontrolledTooltip>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={(event: any) => {
                    const boreholeData = cellProps.row.original;
                    event.preventDefault();
                    onClickDelete(boreholeData);
                  }}
                >
                  <i className="mdi mdi-delete-outline" id="deletetooltip" />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Устгах
                  </UncontrolledTooltip>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-warning"
                  onClick={(event: any) => {
                    const boreholeData = cellProps.row.original;
                    event.preventDefault();
                    handleJobClick(boreholeData);
                  }}
                >
                  <i className="mdi mdi-pencil-outline" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Засах
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    []
  );

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: boreholeOne?.id,
      code: boreholeOne?.code,
      usage_date: boreholeOne?.usage_date,
      is_mineral: boreholeOne?.is_mineral,
      depth: boreholeOne?.depth,
      diameter: boreholeOne?.diameter,
      budget_cost: boreholeOne?.budget_cost,
      cmn_invesetment_source: boreholeOne?.cmn_invesetment_source,
      borehole_design: boreholeOne?.borehole_design,
      bored_organization: boreholeOne?.bored_organization,
      sea_level_m: boreholeOne?.sea_level_m,
      drilling_method_brand: boreholeOne?.drilling_method_brand,
      location: boreholeOne?.location,
    },
    validationSchema: Yup.object({
      code: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      usage_date: Yup.date().typeError("Он сар өдөр оруулна уу").required("Утга оруулна уу !"),
      depth: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      diameter: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("утга оруулна уу !"),
      budget_cost: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      cmn_invesetment_source: Yup.string().typeError("Утга сонгоно уу").required("Утга оруулна уу !"),
      borehole_design: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      bored_organization: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      sea_level_m: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      drilling_method_brand: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      location: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      if (isEdit) {
        const formData = new FormData();

        formData.append('id', boreholeOne ? boreholeOne.id.toString() : '0');
        formData.append('code', values?.code);
        formData.append('usage_date', values?.usage_date);
        formData.append('is_mineral', String(mineralBoolean ?? false));
        formData.append('depth', values?.depth);
        formData.append('diameter', values?.diameter);
        formData.append('budget_cost', values?.budget_cost);
        formData.append('cmn_invesetment_source', values?.cmn_invesetment_source);
        formData.append('borehole_design', values?.borehole_design);
        formData.append('bored_organization', values?.bored_organization);
        formData.append('sea_level_m', values?.sea_level_m);
        formData.append('drilling_method_brand', values?.drilling_method_brand);
        formData.append('location', values?.location);
        boreholeUpdate(formData)
      } else {
        const formData = new FormData();

        formData.append('code', values?.code);
        formData.append('usage_date', values?.usage_date);
        formData.append('is_mineral', String(mineralBoolean ?? false));
        formData.append('depth', values?.depth);
        formData.append('diameter', values?.diameter);
        formData.append('budget_cost', values?.budget_cost);
        formData.append('cmn_invesetment_source', values?.cmn_invesetment_source);
        formData.append('borehole_design', values?.borehole_design);
        formData.append('bored_organization', values?.bored_organization);
        formData.append('sea_level_m', values?.sea_level_m);
        formData.append('drilling_method_brand', values?.drilling_method_brand);
        formData.append('location', values?.location);

        if (selectedFiles && selectedFiles.length > 0) {
          selectedFiles.forEach((file: File, index: number) => {
            formData.append(`shapes`, file);
          });
        }

        boreholeCreate(formData)
      }
      validation.resetForm();
      setmodal_backdrop(false)
    },
  });

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  return (
    <React.Fragment>
      <DeleteModal
        deleteName={boreholeOne?.name}
        show={deleteModal}
        onDeleteClick={handleDeletejob}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Col xl={9}>
        <Card>
          <CardBody className="border-bottom">
            <div className="d-flex align-items-center">
              <img src={boreholeSvg} alt="" height="50" />
              <div className="flex-grow-1 ms-3">
                <h5 className="fw-semibold">Мэдээлэл</h5>
                <ul className="list-unstyled hstack gap-2 mb-0">
                  <li>
                    <i className="mdi mdi-table-row-height"></i>{" "}
                    <span className="text-muted fw-semibold">
                      Нийт: {numberWithCommas(boreholeCount)}{" "}
                    </span>
                  </li>
                </ul>
              </div>
              <button
                type="button"
                onClick={() => {
                  toggle();
                  setBoreholeOne(null);
                }}
                className="btn btn-success  btn-label"
              >
                <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр
                нэмэх
              </button>
            </div>
          </CardBody>

          <CardBody>
            <TableContainer
              setCustomPageSize={setCustomPageSize}
              setCustomPageLength={setCustomPageLength}
              customPagination={customPagination}
              columns={columns}
              data={boreholeList || ""}
              isCustomPageSize={true}
              isPagination={true}
              colWidth={2}
              SearchPlaceholder="Хэрэглэгч хайх . . ."
              tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
              pagination="pagination"
              paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
            />
          </CardBody>
        </Card>
      </Col>

      <Modal
        size="xl"
        isOpen={modal_backdrop}
        toggle={() => {
          toggle();
        }}
        backdrop={"static"}
        id="staticBackdrop"
        centered
      >
        <ModalHeader
          toggle={() => {
            toggle();
          }}
        >
          <div className="h5 modal-title" id="staticBackdropLabel">
            {!!isEdit ? "Цооногийн мэдээлэл засах" : "Цооногийн мэдээлэл нэмэх"}
          </div>
        </ModalHeader>

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <Alert color="warning" className="mb-3">
              <strong className="text-danger">(*)</strong> тэмдэг бүхий талбарыг {""}
              <Link to="#" className="alert-link">
                заавал бөглөх
              </Link>  шаардлагатайг анхаарна уу !!!
            </Alert>
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <Label className="text-danger"> Бүртгэлийн дугаар *</Label>
                  <Input
                    name="code"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.code || ""}
                    invalid={
                      validation.touched.code &&
                        validation.errors.code
                        ? true
                        : false
                    }
                  />
                  {validation.touched.code &&
                    validation.errors.code ? (
                    <FormFeedback type="invalid">
                      {validation.errors.code}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger"> Далайн түвшинээс дээш метр *</Label>
                  <Input
                    name="sea_level_m"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.sea_level_m || ""}
                    invalid={
                      validation.touched.sea_level_m && validation.errors.sea_level_m
                        ? true
                        : false
                    }
                  />
                  {validation.touched.sea_level_m && validation.errors.sea_level_m ? (
                    <FormFeedback type="invalid">
                      {validation.errors.sea_level_m}
                    </FormFeedback>
                  ) : null}
                </div>


                <div className="mb-3">
                  <Label className="text-danger">Рашаан эсэх *</Label> <br />
                  <Switch
                    uncheckedIcon={<Offsymbol />}
                    checkedIcon={<OnSymbol />}
                    className="me-1 mb-sm-8 mb-2 ms-3"
                    onColor="#626ed4"
                    onChange={() => {
                      setMineralBoolean(!mineralBoolean);
                    }}
                    checked={mineralBoolean}
                  />
                </div>

                <div className="mb-3">
                  <Label className="text-danger">Цооногийн гүн, м *</Label>
                  <Input
                    name="depth"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.depth || ""}
                    invalid={
                      validation.touched.depth && validation.errors.depth
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.depth && validation.errors.depth ? (
                    <FormFeedback status="invalid">
                      {validation.errors.depth}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Цооногийн амсрын диаметр, мм*</Label>
                  <Input
                    name="diameter"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.diameter || ""}
                    invalid={
                      validation.touched.diameter && validation.errors.diameter
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.diameter && validation.errors.diameter ? (
                    <FormFeedback status="invalid">
                      {validation.errors.diameter}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Өрөмдлөгйин арга ба суурь машины марк *</Label>
                  <Input
                    name="drilling_method_brand"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.drilling_method_brand || ""}
                    invalid={
                      validation.touched.drilling_method_brand && validation.errors.drilling_method_brand
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.drilling_method_brand && validation.errors.drilling_method_brand ? (
                    <FormFeedback status="invalid">
                      {validation.errors.drilling_method_brand}
                    </FormFeedback>
                  ) : null}
                </div>

              </Col>

              <Col lg={6}>
                <div className="mb-3">
                  <Label className="text-danger">Төсөв өртөг *</Label>
                  <Input
                    name="budget_cost"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.budget_cost || ""}
                    invalid={
                      validation.touched.budget_cost && validation.errors.budget_cost
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.budget_cost && validation.errors.budget_cost ? (
                    <FormFeedback status="invalid">
                      {validation.errors.budget_cost}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">	Хөрөнгө оруулалтын төрөл *</Label>
                  <Input
                    name="cmn_invesetment_source"
                    type="select"
                    className="form-select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.cmn_invesetment_source || ""}
                    invalid={
                      validation.touched.cmn_invesetment_source &&
                        validation.errors.cmn_invesetment_source
                        ? true
                        : false
                    }
                  >
                    <option disabled value="">Сонгох</option>
                    {cost_source?.data?.map((item, index) => (
                      <option value={item?.id}>{item?.name}</option>
                    ))}

                  </Input>
                  {validation.touched.cmn_invesetment_source &&
                    validation.errors.cmn_invesetment_source ? (
                    <FormFeedback type="invalid">
                      {validation.errors.cmn_invesetment_source}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">	Өрөмдсөн байгууллагын нэр *</Label>
                  <Input
                    name="bored_organization"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.bored_organization || ""}
                    invalid={
                      validation.touched.bored_organization &&
                        validation.errors.bored_organization
                        ? true
                        : false
                    }
                  />
                  {validation.touched.bored_organization &&
                    validation.errors.bored_organization ? (
                    <FormFeedback type="invalid">
                      {validation.errors.bored_organization}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Хоолойн хийц *</Label>
                  <Input
                    name="borehole_design"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.borehole_design || ""}
                    invalid={
                      validation.touched.borehole_design && validation.errors.borehole_design
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.borehole_design && validation.errors.borehole_design ? (
                    <FormFeedback status="invalid">
                      {validation.errors.borehole_design}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Ашиглалтанд оруулсан он *</Label>
                  <Input
                    name="usage_date"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.usage_date || ""}
                    invalid={
                      validation.touched.usage_date && validation.errors.usage_date
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.usage_date && validation.errors.usage_date ? (
                    <FormFeedback status="invalid">
                      {validation.errors.usage_date}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Байршил  *</Label>
                  <Input
                    name="location"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.location || ""}
                    invalid={
                      validation.touched.location && validation.errors.location
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.location && validation.errors.location ? (
                    <FormFeedback status="invalid">
                      {validation.errors.location}
                    </FormFeedback>
                  ) : null}
                </div>


              </Col>
            </Row>
            {!!isEdit ? '' :
              <Row>
                <ShapeUpload fileType={'point'} selectFiles={setSelectedFiles} onReset={resetFiles} />
              </Row>
            }

          </ModalBody>

          <div className="modal-footer">
            <button type="button" className="btn btn-light" onClick={() => {
              setmodal_backdrop(false);
            }}>Хаах</button>
            <button type="submit" className="btn btn-primary"> Хадгалах </button>
          </div>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default Detail;
